import { Button, Col, Row, Typography, theme } from "antd";
import React, { PropsWithChildren } from "react";
import { Icons } from "../assets/icons";
import Icon from "@ant-design/icons";
import Loader from "./Loader";

export interface ViewProps {
  readonly open?: boolean;
  readonly loading?: boolean;
  readonly title: string;
  readonly actions?: React.ReactNode;
  readonly onBack?: () => void;
}

function View(props: PropsWithChildren<ViewProps>) {
  const { token } = theme.useToken();

  // Events

  function onBack(): void {
    props.onBack?.();
  }

  return (
    <>
      {props.open && (
        <Col
          className="absolute bottom-0 left-0 right-0 top-0 z-10 flex flex-col"
          style={{
            backgroundColor: token.colorBgContainer,
          }}
        >
          {!props.loading && (
            <>
              <Row className="flex flex-row p-4">
                <Typography.Title className="m-0 flex-auto pr-2" level={4}>
                  {props.title}
                </Typography.Title>
                {props.actions}
                <Button
                  className="ml-4"
                  type={"text"}
                  icon={
                    <Icon className="text-xl" component={Icons.CloseIcon} />
                  }
                  onClick={onBack}
                />
              </Row>
              <Col className="flex flex-col overflow-hidden overflow-y-auto p-2">
                {props.children}
              </Col>
            </>
          )}
          {props.loading && (
            <Col className="flex flex-1 flex-col items-center justify-center opacity-50">
              <Loader />
            </Col>
          )}
        </Col>
      )}
    </>
  );
}

export default View;
